import { NgModule } from '@angular/core';
import { PeersService } from './peers.service';
import { DateRangeService } from './date-range.service';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { OrganisationService } from './organisation.service';
import { CombinedStreamService } from './combined-stream.service';
import { NavigationService } from './navigation.service';
import { SetupService } from './setup.service';
import { MyAccountService } from './my-account.service';

@NgModule({ imports: [CommonModule], providers: [
        PeersService,
        DateRangeService,
        OrganisationService,
        CombinedStreamService,
        NavigationService,
        SetupService,
        MyAccountService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class SingletonServicesModule {}
